import { Controller } from '@hotwired/stimulus'
import axios from 'axios'
import Hammer from 'hammerjs'

export default class extends Controller {
    connect() {
        function closeModalMobile(closeContainer, closeElement) {
            const mc = new Hammer(closeElement)
            mc.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });

            if (closeElement !== null) {
               mc.on("panup pandown", function (ev) {
                  if (ev.deltaY > ev.isFirst) {
                     closeElement.style.transform = `translateY(${ev.deltaY}px)`
                  }

               })
               mc.on('panend', function (ev) {
                  closeElement.style.transform = `translateY(0)`
                  if (ev.deltaY > 30) {
                     closeElement.style.transform = ``
                     closeContainer.classList.remove('active')
                  }
               })
            }
         }
        function dateClick() {
            if (window.innerWidth <= 768 && document.querySelector('.z-calendar .--event')) {
               const events = document.querySelectorAll('.--event')
               events.forEach(event => {
                  const closeContainer = event.querySelector('.event-popup')
                  const closeElement = event.querySelector('.event-popup__wrapper')
                  const eventBtn = event.querySelector('.z-calendar-item__date-value')
                  eventBtn.addEventListener('click', () => {
                     closeContainer.classList.add('active')
                     closeModalMobile(closeContainer, closeElement)
                  })

               })
            }

         }
        class YearCalendar {

            constructor(options) {
               let el
               this.startYear = options.startYear
               this.startMonth = options.startMonth
               this.numberOfMonth = options.numberOfMonth
               this.$el = document.querySelector(options.$el)
               this.weekDaysNames = options.weekDaysNames
               this.monthNames = options.monthNames
            }
            generateMonth(year, month) {
               const days = []
               let dateMonthStart = new Date(year, month, 1)
               let dateMonthEnd = new Date(year, month + 1, 0)
               const weekStarts = dateMonthStart.getDay() === 0 ? 7 : dateMonthStart.getDay()
               const weekEnd = dateMonthEnd.getDay() === 0 ? 7 : dateMonthEnd.getDay()
               let tableStart = new Date(year, month, 1)
               tableStart.setDate(tableStart.getDate() - (weekStarts - 1))
               let tableEnd = dateMonthEnd
               tableEnd.setDate(dateMonthEnd.getDate() + (7 - (weekEnd - 1)))
               while (new Date(tableStart).getTime() !== new Date(tableEnd).getTime()) {
                  const dayObj = {
                     day: tableStart.getDate(),
                     month: tableStart.getMonth(),
                     year: tableStart.getFullYear(),
                     currentMonth: dateMonthStart.getMonth() === tableStart.getMonth() ? true : false,
                  }
                  days.push(dayObj)
                  tableStart.setDate(tableStart.getDate() + 1)
               }

               return days
            }
            generateCalendar() {
               const month = []
               let dateMonthStart = new Date(this.startYear, this.startMonth - 1, 1)
               for (let i = 0; i < this.numberOfMonth; i += 1) {
                  month.push(this.generateMonth(dateMonthStart.getFullYear(), dateMonthStart.getMonth()))
                  dateMonthStart.setMonth(dateMonthStart.getMonth() + 1)
               }

               return month
            }

            displayingCalendar() {
               const monthArr = this.generateCalendar()
               const zСalendar = document.createElement('div')
               zСalendar.classList.add('z-calendar__wrapper')
               this.$el.appendChild(zСalendar)
               monthArr.forEach(month => {

                  const zСalendarItem = document.createElement('div')
                  zСalendarItem.classList.add('z-calendar-item')
                  zСalendarItem.innerHTML = `
                  <div class="z-calendar-item__wrapper">
                     <div class="z-calendar-item__month"></div>
                     <div class="z-calendar-item__weekday-list"></div>
                     <div class="z-calendar-item__date-list"></div>
                     </div>
                  `
                  this.weekDaysNames.forEach(weekday => {
                     let zСalendarWeekDay = document.createElement('div')
                     zСalendarWeekDay.classList.add('z-calendar-item__weekday')
                     zСalendarWeekDay.innerHTML = weekday
                     zСalendarItem.querySelector('.z-calendar-item__weekday-list').appendChild(zСalendarWeekDay)
                  })
                  month.forEach(dayObj => {
                     let zСalendarDate = document.createElement('div')
                     zСalendarDate.classList.add('z-calendar-item__date')
                     if (dayObj.currentMonth) {
                        if (!zСalendarItem.querySelector('.z-calendar-item__month').innerHTML) {
                           zСalendarItem.querySelector('.z-calendar-item__month').innerHTML = this.monthNames[dayObj.month]
                        }
                        zСalendarDate.classList.add('z-calendar-item__current-month')
                        zСalendarDate.setAttribute('data-date', `${dayObj.day <= 9 ? '0' + dayObj.day : dayObj.day}.${(dayObj.month + 1) <= 9 ? '0' + (dayObj.month + 1) : (dayObj.month + 1)}.${dayObj.year}`)
                     }
                     zСalendarDate.innerHTML = `<div class="z-calendar-item__date-value">${dayObj.day}</div>`
                     zСalendarItem.querySelector('.z-calendar-item__date-list').appendChild(zСalendarDate)
                  })

                  zСalendar.appendChild(zСalendarItem)
               })

            }

         }

         if (document.querySelector('.z-calendar')) {
            const calendar = new YearCalendar({
               startYear: 2023, // Год с которого начинается календарь (2023)
               startMonth: new Date().getMonth() + 1, // Месяц с которого начинается календарь (1 - 12)
               numberOfMonth: 12, // Количество месяцев которое будут выводится (12)
               $el: '.z-calendar', // Контейнер для календаря
               weekDaysNames: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'], // Названия дней недели которые будут выводиться
               monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'] // Названия месяцев которые будут выводиться

            })
            calendar.displayingCalendar()










            axios.get('https://urbancommunity.ru/api/events_calendar').then(resp => {

               const eventsData = resp.data
               const eventTypes = []
               eventsData.forEach(event => {
                  const eventDateEl = document.querySelector(`[data-date="${event.data}"]`)
                  const dateArr = event.data.split('.')

                  if (!eventTypes.find(id => event.type.id === id)) {
                     eventTypes.push(event.type.id)
                     const eventButton = document.createElement('button')
                     eventButton.classList.add('calendar-events__btn')
                     eventButton.setAttribute('data-event-type', event.type.id)
                     eventButton.innerHTML = event.type.title
                     if (event.type.color) {
                        eventButton.style = `background-color: ${event.type.color}; border-color: ${event.type.color};`
                     }
                     document.querySelector('.calendar-events__buttons').appendChild(eventButton)
                     eventButton.addEventListener('click', () => {
                        const dates = document.querySelectorAll(`.z-calendar-item__date[data-event-type="${event.type.id}"]`)
                        if (eventButton.classList.contains('--disabled')) {
                           dates.forEach(date => {
                              date.classList.remove('--disabled')
                           })
                           eventButton.classList.remove('--disabled')
                        } else {
                           dates.forEach(date => {
                              date.classList.add('--disabled')
                           })
                           eventButton.classList.add('--disabled')
                        }
                     })
                  }
                  if (!document.querySelector(`[popup-date="${event.data}"]`)) {
                     eventDateEl.classList.add('--event')
                     if (event.type.color) {
                        eventDateEl.style = `background-color: ${event.type.color}; border-color: ${event.type.color};`
                     }

                     eventDateEl.setAttribute('data-event-type', event.type.id)
                     const leftPos = eventDateEl.getBoundingClientRect().left
                     const rightPos = window.innerWidth - leftPos
                     const eventPopup = document.createElement('div')
                     eventPopup.classList.add('event-popup')
                     leftPos > rightPos ? eventPopup.classList.add('event-popup--left') : eventPopup.classList.remove('event-popup--left')
                     eventPopup.setAttribute('popup-date', event.data)
                     eventPopup.innerHTML = `
                  <div class="event-popup__wrapper">
                     <div class="event-popup__top-line js-tap-close"></div>
                     <div class="event-popup__date">
                          <div class="event-popup__day">${dateArr[0]}</div>
                          /
                          <div class="event-popup__month">${dateArr[1]}</div>
                     </div>
                     <div class="event-popup__item-list"></div>
                  </div>
                  `
                     eventDateEl.appendChild(eventPopup)
                  }
                  const eventPopupItem = document.createElement('div')
                  eventPopupItem.classList.add('event-popup__item')
                  eventPopupItem.innerHTML = `
                  <a href="${event.url}" class="event-popup__item-wrapper">
                     <div class="event-popup__name">${event.title}</div>
                     <div class="event-popup__address">
                        <i class="icon-map-mark"></i>
                        <span class="event-popup__address-value">${event.location_city}</span>
                     </div>
                  </a>
                  `
                  document.querySelector(`[popup-date="${event.data}"] .event-popup__item-list`).appendChild(eventPopupItem)
               })

               dateClick()
            });

         }

    }

    disconnect() {
        // this.choices.destroy()
    }
}
